var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { observer } from 'mobx-react';
import cxs from 'cxs';
var styles = {
    channelList: cxs({
        fontSize: '0.85rem',
    }),
    channelItem: cxs({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #eee',
    }),
};
var ChannelBreakdown = observer(function (_a) {
    var slot = _a.slot;
    var channels = __spreadArray([
        { name: 'Ventas propias', value: slot.sold.own },
        { name: 'Colaboradores', value: slot.sold.collaborator }
    ], Object.entries(slot.sold.external).map(function (_a) {
        var name = _a[0], value = _a[1];
        return ({
            name: name.charAt(0).toUpperCase() + name.slice(1),
            value: value,
        });
    }), true);
    return (React.createElement("div", { className: styles.channelList }, channels.map(function (channel) { return (React.createElement("div", { key: channel.name, className: styles.channelItem },
        React.createElement("span", null, channel.name),
        React.createElement("strong", null, channel.value))); })));
});
export default ChannelBreakdown;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/ChannelBreakdown.tsx
// module id = 1615
// module chunks = 0